import { useEffect } from 'react';
import { useDataTable } from '../DataTableProvider';

/**
 * Prevent scrolling when cell is in active edit mode
 *
 * This hook adds a mousewheel event listener when a cell is active,
 * preventing scroll events from propagating to avoid losing focus during editing.
 * Uses AbortController for cleanup (modern pattern matching useScrollSync).
 *
 * @param active - Whether the cell is in active edit mode
 */
export const useCellScrollLock = (active: boolean): void => {
  const { dataTableService } = useDataTable();

  useEffect(() => {
    if (active && !dataTableService.readonly) {
      const abortController = new AbortController();

      const handleScroll = (event: Event) => {
        event.stopPropagation();
        event.preventDefault();
        // Blur is handled by the component that owns the inputRef
        // This just prevents the scroll event from propagating
      };

      window.addEventListener('mousewheel', handleScroll, {
        signal: abortController.signal,
        passive: false,
      });

      return () => {
        abortController.abort();
      };
    }
  }, [active, dataTableService.readonly]);
};
